var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"branding-logo",class:{ 'is-filled': _vm.filled },attrs:{"data-unit-test":"branding-logo"}},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }